import { render, staticRenderFns } from "./CompanyRegister.vue?vue&type=template&id=0c51b668&scoped=true&"
import script from "./CompanyRegister.vue?vue&type=script&lang=js&"
export * from "./CompanyRegister.vue?vue&type=script&lang=js&"
import style0 from "./CompanyRegister.vue?vue&type=style&index=0&id=0c51b668&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c51b668",
  null
  
)

export default component.exports